import { render, staticRenderFns } from "./EventsFromIntegrationWidget.vue?vue&type=template&id=b1b9534e&scoped=true&"
import script from "./EventsFromIntegrationWidget.vue?vue&type=script&lang=js&"
export * from "./EventsFromIntegrationWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventsFromIntegrationWidget.vue?vue&type=style&index=0&id=b1b9534e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b9534e",
  null
  
)

export default component.exports